import React, { useEffect, useState } from 'react';
import { Menu, X } from './Icons';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qz1dADs31rdediUFi9XLPf/Logo.png';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Eventos',
    href: '#eventos'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-warm-white/95 backdrop-blur-sm shadow-sm py-2 md:py-2' : 'bg-transparent py-3 md:py-4'}`} data-id="element-197">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        {/* Desktop: Logo centered above nav */}
        <div className="hidden md:flex flex-col items-center" data-id="element-199">
          <a href="#" className="mb-2" data-id="element-200">
            <img src={LOGO_URL} alt="DeliSandwiches - Servicios de Lunch" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-14 brightness-0' : 'h-20'}`} data-id="element-201" />
          </a>
          <nav className="flex items-center gap-8" data-id="element-202">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wide transition-colors ${isScrolled ? 'text-deep-brown hover:text-terracotta' : 'text-cream/90 hover:text-white'}`} data-id="element-203">
                {link.name}
              </a>)}
            <a href="#contacto" className="bg-terracotta hover:bg-terracotta-dark text-white px-6 py-2.5 rounded-sm transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md" data-id="element-204">
              Contáctenos
            </a>
          </nav>
        </div>

        {/* Mobile: Logo centered with hamburger */}
        <div className="flex md:hidden justify-between items-center" data-id="element-205">
          <button className={`z-50 p-2 ${isScrolled ? 'text-deep-brown' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-206">
            {isMobileMenuOpen ? <X size={24} data-id="element-207" /> : <Menu size={24} data-id="element-208" />}
          </button>

          <a href="#" className="absolute left-1/2 -translate-x-1/2" data-id="element-209">
            <img src={LOGO_URL} alt="DeliSandwiches - Servicios de Lunch" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-10 brightness-0' : 'h-12'}`} data-id="element-210" />
          </a>

          <div className="w-10" data-id="element-211"></div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-212">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="absolute top-full left-0 right-0 bg-warm-white shadow-lg border-t border-sand md:hidden" data-id="element-213">
            <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-214">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-deep-brown hover:text-terracotta text-lg font-medium py-2 border-b border-sand/50" data-id="element-215">
                  {link.name}
                </a>)}
              <a href="#contacto" onClick={() => setIsMobileMenuOpen(false)} className="bg-terracotta text-white text-center px-6 py-3 rounded-sm mt-4 font-medium" data-id="element-216">
                Contáctenos
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}